
import React from 'react';

const Share = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='49'
			height='48'
			fill='none'
			viewBox='0 0 49 48'
		>
			<g
				stroke='#2d2d2d'
				strokeLinecap='round'
				strokeLinejoin='round'
				strokeWidth='3'
				clipPath='url(#clip0_3540_9259)'
			>
				<path d='M36.5 16a6 6 0 100-12 6 6 0 000 12zM12.5 30a6 6 0 100-12 6 6 0 000 12zM36.5 44a6 6 0 100-12 6 6 0 000 12zM17.68 27.02l13.66 7.96M31.32 13.02l-13.64 7.96'></path>
			</g>
			<defs>
				<clipPath id='clip0_3540_9259'>
					<path fill='#fff' d='M0 0H48V48H0z' transform='translate(.5)'></path>
				</clipPath>
			</defs>
		</svg>
	);
};

export default Share;
